/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCustomerService = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M12 15c3 0 5.261.703 6.788 1.992C20.336 18.3 21 20.1 21 22v1h-2v-1c0-1.416-.479-2.616-1.502-3.48C16.453 17.638 14.714 17 12 17c-2.715 0-4.453.638-5.498 1.52C5.479 19.384 5 20.584 5 22v1H3v-1c0-1.9.664-3.7 2.212-5.008C6.739 15.703 9 15 12 15zm-.006-14c1.045 0 2.08.196 3.048.578a8.04 8.04 0 0 1 2.596 1.654 7.67 7.67 0 0 1 1.746 2.493c.321.74.521 1.48.589 2.275H21v4h-3v-1h-1.417A5 5 0 1 1 17 9h1v-.4c0-.726-.147-1.38-.45-2.079a5.67 5.67 0 0 0-1.292-1.841 6.04 6.04 0 0 0-1.95-1.242 6.308 6.308 0 0 0-4.628 0A6.04 6.04 0 0 0 7.73 4.68a5.668 5.668 0 0 0-1.293 1.84A5.03 5.03 0 0 0 6 8.6V12H3V8h1.026c.064-.788.254-1.53.578-2.275.407-.935 1-1.782 1.746-2.493a8.04 8.04 0 0 1 2.595-1.654A8.307 8.307 0 0 1 11.995 1zM12 6a3 3 0 1 0 0 6 2.99 2.99 0 0 0 2.231-1h-2.237V9H15a3 3 0 0 0-3-3z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgCustomerService as CustomerService };
